<div class="empty-template">
    <i class="icon-file"></i>
    <span class="text">{{ text | translate }}</span>
</div>